import { Dispatch } from 'redux';
import { TicketCloseInfo } from '../../Interfaces/Tickets/TicketCloseInfo';
import { actionCreators } from './TicketsState';

export const resetState = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.resetState());
};

export const fetchTickets = async (
  dispatch: Dispatch<any>,
  getClosed: boolean,
  noFilter: boolean,
) => {
  return dispatch(actionCreators.fetchTickets(getClosed, noFilter));
};

export const sendCloseTicket = async (
  dispatch: Dispatch<any>,
  ticketId: number,
  ticketCloseInfo: TicketCloseInfo
) => {
  return dispatch(actionCreators.sendCloseTicket(ticketId, ticketCloseInfo));
};

export const resetTicketsError = async (dispatch: any) => {
  return dispatch(actionCreators.resetTicketsError());
};

export const clearCloseTicketNotificationSuccessMessage = async (
  dispatch: any
) => {
  return dispatch(actionCreators.clearCloseTicketNotificationSuccessMessage());
};

export const getTicketStoreList = async (dispatch: any) => {
  return dispatch(actionCreators.getTicketStoreList());
};

export const getTicketDivisionList = async (dispatch: any) => {
  return dispatch(actionCreators.getTicketDivisionList());
};

export const getTicketNodeTypeList = async (dispatch: any) => {
  return dispatch(actionCreators.getTicketNodeTypeList());
};

export const getTicketLaneNumbers = async (dispatch: any) => {
  return dispatch(actionCreators.getTicketLaneNumbers());
};

export const getTicketNodeGroups = async (dispatch: any) => {
  return dispatch(actionCreators.getTicketNodeGroups());
};
